import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const getMonthName = (periodo) => {
  const parts = periodo.split("-");
  const month = parts[1];
  const months = {
    "01": "Enero",
    "02": "Febrero",
    "03": "Marzo",
    "04": "Abril",
    "05": "Mayo",
    "06": "Junio",
    "07": "Julio",
    "08": "Agosto",
    "09": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
  };
  return `${months[month]} ${parts[0]}` || periodo;
};

const DashboardAnalyticsDocs = ({ data }) => {
  const [showTable, setShowTable] = useState(false);
  
  const detalleTotalesChartData = {
    labels: data.map((item) => getMonthName(item.mes)),
    datasets: [
      {
        label: "Factura Afecta",
        data: data.map((item) => item.documento_total?.f_afecta ?? 0),
        backgroundColor: "#42A5F5",
        borderColor: "#42A5F5",
        borderWidth: 2,
      },
      {
        label: "Factura Exenta",
        data: data.map((item) => item.documento_total?.f_exenta ?? 0),
        backgroundColor: "#66BB6A",
        borderColor: "#66BB6A",
        borderWidth: 2,
      },
      {
        label: "Nota De Cobro",
        data: data.map((item) => item.documento_total?.n_cobro ?? 0),
        backgroundColor: "#FFA726",
        borderColor: "#FFA726",
        borderWidth: 2,
      },
    ],
  };
  const chartOptions = {
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
      x: { categoryPercentage: 0.9, barPercentage: 0.8 },
    },
  };
  return (
    <div className="grid dashboard">
      <div className="col-12">
        <div className="card">
          <h5>Totales por Documentos</h5>
          <Chart
            type="bar"
            data={detalleTotalesChartData}
            options={chartOptions}
            height="400px"
          />

          <div className="mt-3" style={{ display: "flex", justifyContent: "center" }}>
            <button
              icon="pi pi-exchange"
              className="p-button-secondary p-button-raised p-button p-button-rounded"
              onClick={() => setShowTable(!showTable)}
            >
              {showTable ? "Ocultar Detalle" : "Mostrar Detalle"}
            </button>
          </div>
          
          {showTable && (
            <div className="mt-5">
              <DataTable
                value={data} 
                stripedRows
                showGridlines
                className="mt-3"
              >
                <Column
                  header="Mes"
                  body={(rowData) => getMonthName(rowData.mes)}
                />

                <Column
                  field="f_afecta"
                  header="Factura Afecta"
                  body={(rowData) => `UF ${(rowData.documento_total.f_afecta || 0).toFixed(2)}`}
                />
                <Column
                  field="f_exenta"
                  header="Factura Exenta"
                  body={(rowData) => `UF ${(rowData.documento_total.f_exenta || 0).toFixed(2)}`}
                />
                <Column
                  field="n_cobro"
                  header="Nota De Cobro"
                  body={(rowData) => `UF ${(rowData.documento_total.n_cobro || 0).toFixed(2)}`}
                />
                <Column
                  field="total"
                  header="Total UF"
                  body={(rowData) => `UF ${(rowData.totalPfUfFinal || 0).toFixed(2)}`}
                />
              </DataTable>
            </div>
          )}
        </div>
        
      </div>
    </div>
  );
};

export default React.memo(DashboardAnalyticsDocs);
